'use client'
import { createContext } from 'react'

export type AuthContextType = {
  isAuth: boolean
  token: string | null
}

export const INITIAL_AUTH_CONTEXT: AuthContextType = {
  token: null,
  isAuth: false,
}

export const AuthContext = createContext<AuthContextType>(INITIAL_AUTH_CONTEXT)

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const AuthContextStateSetter = createContext<(state: AuthContextType) => void>(() => {})
